
// Test data for Level 2 Driver Training

export const driverTests = [
  {
    id: "driver-practice",
    title: "Driver au practice",
    description: "Sur le practice, taper 10 balles avec un driver vers une cible à 180 m, noter les distances et les écarts.",
    icon: "🏌️‍♂️"
  },
  {
    id: "driver-accuracy",
    title: "Précision au driver",
    description: "Sur le practice, taper 10 balles avec un driver en visant un couloir de 25 m de large à 180 m, compter les balles qui restent dans le couloir.",
    icon: "🏌️‍♂️"
  }
];
